var _a;
import { createActions } from 'redux-actions';
export var getCollection = (_a = createActions('GET_COLLECTION', 'GET_COLLECTION_COMPLETE'), _a.getCollection), getCollectionComplete = _a.getCollectionComplete;
